document.addEventListener("DOMContentLoaded", function () {
  const pricingSection = document.getElementById("gca-pricing");
  if (!pricingSection) return;

  document.body.addEventListener("click", function (e) {
    const card = e.target.closest(".gca-grader-card");
    if (!card) return;

    const text = card.textContent.toLowerCase();
    let grader = null;

    if (text.includes("beckett") || text.includes("bgs")) grader = "bgs";
    if (text.includes("sgc")) grader = "sgc";
    if (text.includes("cga")) grader = "cga";
    if (!grader) return;

    e.preventDefault();

    const headers = pricingSection.querySelectorAll("h2[data-grader]");

    // reset everything
    headers.forEach(h => {
      h.classList.remove("gca-pricing-active");
      let el = h.nextElementSibling;
      while (el && el.tagName !== "H2") {
        el.classList.remove("gca-pricing-dim");
        el = el.nextElementSibling;
      }
    });

    const activeHeader = pricingSection.querySelector(
      `h2[data-grader="${grader}"]`
    );
    if (!activeHeader) return;

    activeHeader.classList.add("gca-pricing-active");

    // dim everything except active section
    headers.forEach(h => {
      if (h === activeHeader) return;

      let el = h.nextElementSibling;
      while (el && el.tagName !== "H2") {
        el.classList.add("gca-pricing-dim");
        el = el.nextElementSibling;
      }
    });

    pricingSection.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  });
});
